import React from 'react';
import Icon from '@atlaskit/icon';
import { CustomGlyphProps } from '@atlaskit/icon/types';

import { IconProps } from './interface';

const SortUpGlyph = (props: CustomGlyphProps) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        data-testid={props['data-testid']}
        aria-label={props['aria-label']}
        className={props.className}>
        <path
            d="M6 7.5C6 7.08579 6.33579 6.75 6.75 6.75H11.75C12.1642 6.75 12.5 7.08579 12.5 7.5C12.5 7.91421 12.1642 8.24999 11.75 8.24999H6.75C6.33579 8.24999 6 7.91421 6 7.5ZM6 10.5C6 10.0858 6.33579 9.74999 6.75 9.74999H10.75C11.1642 9.74999 11.5 10.0858 11.5 10.5C11.5 10.9142 11.1642 11.25 10.75 11.25H6.75C6.33579 11.25 6 10.9142 6 10.5ZM6.75 12.75C6.33579 12.75 6 13.0858 6 13.5C6 13.9142 6.33579 14.25 6.75 14.25H9.75C10.1642 14.25 10.5 13.9142 10.5 13.5C10.5 13.0858 10.1642 12.75 9.75 12.75H6.75ZM6 16.5C6 16.0858 6.33579 15.75 6.75 15.75H8.75C9.16421 15.75 9.5 16.0858 9.5 16.5C9.5 16.9142 9.16421 17.25 8.75 17.25H6.75C6.33579 17.25 6 16.9142 6 16.5ZM16.6623 10.2725L15.75 9.36833V16.5C15.75 16.9142 15.4142 17.25 15 17.25C14.5858 17.25 14.25 16.9142 14.25 16.5V9.36833L13.3377 10.2725C13.0317 10.5758 12.5356 10.5758 12.2296 10.2725C11.9235 9.96921 11.9235 9.47747 12.2296 9.17417L14.4459 6.97748C14.752 6.67418 15.2481 6.67418 15.5541 6.97748L17.7705 9.17417C18.0765 9.47747 18.0765 9.96921 17.7705 10.2725C17.4645 10.5758 16.9683 10.5758 16.6623 10.2725Z"
            fill="currentColor"
        />
    </svg>
);

const SortUpIcon = (props: IconProps) => {
    return <Icon {...props} glyph={SortUpGlyph} label={props.label ?? ''}/>;
};

export default SortUpIcon;